/**
 * @fileoverview > handler for the "/engagement/campaign_schedule_summary" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignScheduleSummaryCacheKeys } from "./constants";
import type { EngagementCampaignScheduleSummaryResult, putEngagementCampaignScheduleSummaryProps } from "./types";

export const putEngagementCampaignScheduleSummary = reactQueryMutationAdapter(
  engagementCampaignScheduleSummaryCacheKeys,
  async (data: putEngagementCampaignScheduleSummaryProps): Promise<EngagementCampaignScheduleSummaryResult> => {
    return fetch("/engagement/campaign_schedule_summary", "PUT", data);
  }
);
